/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function GitCommit({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M10.527 8.592a2.594 2.594 0 0 1-5.054 0H1.6a.6.6 0 0 1 0-1.2h3.88a2.594 2.594 0 0 1 5.04 0h3.88a.6.6 0 1 1 0 1.2zm-.934-.585a1.593 1.593 0 1 1-3.186 0 1.593 1.593 0 0 1 3.186 0" clipRule="evenodd" /></svg>;
}
;